/**
 * Circle Selection Configuration Interface
 * Used for the new circle selection tool with configurable radius
 */

export enum RadiusUnit {
    METERS = 'meters',
    KILOMETERS = 'kilometers',
    MILES = 'miles',
    FEET = 'feet'
}

export interface CircleSelectionConfig {
    radiusValue: number;
    radiusUnit: RadiusUnit;
    radiusInMeters: number; // Normalized value for Google Maps
}

export interface CircleSelectionState {
    isConfigPanelOpen: boolean;
    isPlacementMode: boolean;
    config: CircleSelectionConfig | null;
    createdCircle: any | null; // Google Maps Circle object
}
